import { ZIndex } from '../../../../util/styles/zIndex';
import { makeStyles } from '../../../../util/styling';
import { tokens } from '../../../../util/theme/fluent9';

export const useClassNames = makeStyles({
  footer: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: ZIndex.PageLayoutFooter,
    width: '100%',
    backgroundColor: tokens.colorNeutralForegroundInverted,
    boxShadow: '0px 4.8px 14.4px rgba(0, 0, 0, 0.18)',
  },
});
